/* eslint-disable no-param-reassign, no-new, no-undef */
import { useEffect, useState, useRef } from 'react';
import GoogleMapReact from 'google-map-react';
import { Switch } from '@headlessui/react';
import { GoogleMap, LoadScript } from '@react-google-maps/api';
import { nanoid } from 'nanoid';
import { useTranslation } from '@/helpers/translate';
import googleOptions from '@/core/google-options.js';

function GoogleMapOR({ location }) {
  const { t } = useTranslation();
  const [isRender, setRender] = useState(false);
  const [cmpSwitch, setCmpSwitch] = useState();
  const [mapComponents, setMapComponents] = useState({});
  const [enabled, setEnabled] = useState(false);
  const [loadedKey] = useState(nanoid());
  const containerStyle = {
    width: '100%',
    height: '100%',
  };

  useEffect(() => {
    if (window) {
      setRender(true);
    }
  }, []);

  useEffect(() => {
    const { map, transitLayer } = mapComponents;
    if (map && transitLayer) {
      if (enabled) transitLayer.setMap(map);
      else transitLayer.setMap(null);
    }
  }, [enabled]);

  if (!isRender) return null;

  const ZoomControl = (controlDiv, map) => {
    // Creating divs & styles for custom zoom control
    controlDiv.style.padding = '5px';

    // Set CSS for the control wrapper
    const controlWrapper = document.createElement('div');
    controlWrapper.classList.add('zoom-popin');
    controlDiv.appendChild(controlWrapper);

    // Set CSS for the zoomIn
    const zoomInButton = document.createElement('div');
    zoomInButton.classList.add('zoom-in');
    zoomInButton.innerHTML += '<svg xmlns="http://www.w3.org/2000/svg" width="1.4em" height="1.4em" viewBox="0 0 14 14"><path d="M6 6H1.007a1 1 0 100 2H6v4.993a1 1 0 102 0V8h4.993a1 1 0 100-2H8V1.007a1 1 0 10-2 0V6z"></path></svg>';
    controlWrapper.appendChild(zoomInButton);

    const separator = document.createElement('div');
    separator.classList.add('separator');
    controlWrapper.appendChild(separator);
    // Set CSS for the zoomOut
    const zoomOutButton = document.createElement('div');
    zoomOutButton.classList.add('zoom-out');
    zoomOutButton.innerHTML += '<svg xmlns="http://www.w3.org/2000/svg" width="1.4em" height="1.4em" viewBox="0 0 1 1"><path d="M0.0719285714,0.428571429 C0.0324796607,0.428571429 0.0005,0.460551089 0.0005,0.5 C0.0005,0.539448911 0.0324796607,0.571428571 0.0719285714,0.571428571 L0.928071429,0.571428571 C0.967520339,0.571428571 0.9995,0.539448911 0.9995,0.5 C0.9995,0.460551089 0.967520339,0.428571429 0.928071429,0.428571429 L0.0719285714,0.428571429 Z"></path></svg>';
    controlWrapper.appendChild(zoomOutButton);

    // Setup the click event listener - zoomIn
    zoomInButton.addEventListener('click', () => {
      map.setZoom(map.getZoom() + 1);
    });
    // Setup the click event listener - zoomOut
    zoomOutButton.addEventListener('click', () => {
      map.setZoom(map.getZoom() - 1);
    });
  };

  const handleApiLoaded = (map, maps) => {
    const svgHouse = {
      path:
        'M8.602 1.147l.093.08 7.153 6.914-.696.718L14 7.745V14.5a.5.5 0 0 1-.41.492L13.5 15H10V9.5a.5.5 0 0 0-.41-.492L9.5 9h-3a.5.5 0 0 0-.492.41L6 9.5V15H2.5a.5.5 0 0 1-.492-.41L2 14.5V7.745L.847 8.86l-.696-.718 7.153-6.915a1 1 0 0 1 1.297-.08z',
      fillColor: 'white',
      fillOpacity: 1,
      strokeWeight: 0,
      rotation: 0,
      scale: 1.5,
      anchor: new maps.Point(8, 10),
    };
    const svgCircle = {
      path: 'M-20,0a20,20 0 1,0 40,0a20,20 0 1,0 -40,0',
      fillColor: '#865FFF',
      fillOpacity: 1,
      strokeWeight: 0,
      rotation: 0,
      scale: 1.5,
      anchor: new maps.Point(0, 0),
    };
    new maps.Circle({
      // eslint-disable-line no-unused-vars
      center: new maps.LatLng(location.lat, location.lng),
      map,
      strokeColor: '#865FFF',
      strokeOpacity: 0,
      strokeWeight: 2,
      fillColor: '#865FFF',
      fillOpacity: 0.3,
      radius: 460,
    });
    new maps.Marker({
      // eslint-disable-line no-unused-vars
      position: new maps.LatLng(location.lat, location.lng),
      map,
      icon: svgCircle,
    });
    new maps.Marker({
      // eslint-disable-line no-unused-vars
      position: new maps.LatLng(location.lat, location.lng),
      map,
      icon: svgHouse,
    });

    const zoomControlDiv = document.createElement('div');
    new ZoomControl(zoomControlDiv, map);
    zoomControlDiv.index = 1;
    map.controls[google.maps.ControlPosition.TOP_RIGHT].push(zoomControlDiv);

    map.controls[maps.ControlPosition.LEFT_TOP].push(cmpSwitch);
    setMapComponents({ map, transitLayer: new maps.TransitLayer() });
  };

  return (
    <div className="w-full h-full">
      <LoadScript googleMapsApiKey={process.env.NEXT_PUBLIC_GOOGLE_API_KEY}>
        <div className="w-full h-full">
          <GoogleMap
            onLoad={(map) => {
              /*
                hack, it will be call twice
                and handleApiLoaded, ZoomControl will add twice by JS Native
              */
              if (window && window?.ORSpaceGoogleLoadedKey !== loadedKey) {
                handleApiLoaded(map, window.google.maps);
                window.ORSpaceGoogleLoadedKey = loadedKey;
              }
            }}
            mapContainerStyle={containerStyle}
            center={{ ...location }}
            zoom={14}
            options={{
              maxZoom: 16,
              minZoom: 10,
              disableDefaultUI: true,
              scrollwheel: false,
              navigationControl: false,
              mapTypeControl: false,
              scaleControl: false,
              fullscreenControl: false,
              draggable: true,
              streetViewControl: true,
              zoomControl: false,
              styles: googleOptions,
            }}
          />
        </div>
      </LoadScript>
    <div
      className="flex items-center px-3 py-2 m-4 font-sans bg-white rounded-lg z-5 shadow-button"
      ref={setCmpSwitch}
    >
      <Switch
        checked={enabled}
        onChange={setEnabled}
        className={`transition ease-in-out duration-400 ${
          enabled ? 'bg-purple' : 'bg-purple-1'
        } relative inline-flex items-center h-7 rounded-full w-12`}
      >
        <span className="sr-only">{t('btn:transit')}</span>
        <span
          className={`transform transition ease-in-out duration-200 ${
            enabled ? 'translate-x-6' : 'translate-x-1'
          } inline-block size-5 transform bg-white rounded-full`}
        />
      </Switch>
      <span className="ml-2 text-base font-medium font-display">{t('btn:transit')}</span>
    </div>
    </div>
  );
}

export default function TimerGoogleMapOR(props) {
  const [show, setShow] = useState(false);
  const [mapId] = useState(() => nanoid());
  const mapRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShow(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 },
    );

    if (mapRef.current) {
      observer.observe(mapRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={mapRef}
      className="relative w-full h-full overflow-hidden rounded-xl bg-purple-0"
      key={mapId}
    >
      {!show ? null : <GoogleMapOR {...props} key={mapId} />}
    </div>
  );
}
